<div class="container-fluid">
  <div>
    <!--<app-loading></app-loading>-->
  </div>

  <h1 class="h3 mb-2 text-gray-800">Membership plan</h1>

  <div class="card shadow mb-4">
    <div class="card-body">
      <div class="table-responsive"></div>
    </div>
  </div>
</div>
